export default Object.freeze({
    sortNum(a,b){
      if(a<b) return -1;
      if(a>b) return 1;
      return 0;
    },
    sort(a, b) {

        let replacedA = this.replaceInt(a)
        let replacedB = this.replaceInt(b)

        let aMatch = replacedA.match(/\d+/)
        let bMatch = replacedB.match(/\d+/)

        if (aMatch && bMatch) {
            return aMatch - bMatch;
        }
        if (aMatch && !bMatch) {
            return 1;
        }
        if (!aMatch && bMatch) {
            return -1;
        }
        return a.localeCompare(b);

    },

    replaceInt(text) {
        return text.replaceAll("０", "0")
            .replaceAll("１", "1")
            .replaceAll("２", "2")
            .replaceAll("３", "3")
            .replaceAll("４", "4")
            .replaceAll("５", "5")
            .replaceAll("６", "6")
            .replaceAll("７", "7")
            .replaceAll("８", "8")
            .replaceAll("９", "9")
    }
});